var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"site-logo"},[_c('img',{attrs:{"src":require("../assets/images/extra-logo.png")}})])])
}]

export { render, staticRenderFns }